/**
 * 页面文案词典 —— 中文（源语言）
 * 第五批：合规 · 制裁名单筛查复核页（Compliance/SanctionsReview）
 */
export default {
  // ---- 菜单（ProLayout 查 menu. 前缀，同时留裸 key 兜底）----
  'menu.制裁筛查复核': '制裁筛查复核',
  '制裁筛查复核': '制裁筛查复核',

  // ---- 页面 ----
  '制裁名单筛查': '制裁名单筛查',
  '命中总数': '命中总数',
  '待复核': '待复核',
  '确认命中': '确认命中',
  '误报放行': '误报放行',
  '已处置': '已处置',
  '名单条目数': '名单条目数',
  '同步时间': '同步时间',
  '数据年龄': '数据年龄',
  '小时': '小时',
  '名单尚未同步，请检查定时任务 /usr/local/bin/sync-sanctions.php': '名单尚未同步，请检查定时任务 /usr/local/bin/sync-sanctions.php',
  'ID': 'ID',
  '个人': '个人',
  '查询名称': '查询名称',
  '命中的名单条目': '命中的名单条目',
  '名单项目': '名单项目',
  '匹配度': '匹配度',
  '处置说明': '处置说明',
  '处置说明（可选）': '处置说明（可选）',
  '命中时间': '命中时间',
  '确认识别为名单对象': '确认识别为名单对象',
  '判定为误报': '判定为误报',
  '确认识别必须填写处置说明': '确认识别必须填写处置说明',
  '处置成功': '处置成功',

  // ===== 管理员管理（09-28 新增编辑口子）=====
  '管理员': '管理员',
  '管理员列表': '管理员列表',
  '未填写': '未填写',
  '编辑管理员': '编辑管理员',
  '密码留空表示不修改': '密码留空表示不修改',
  '更新成功': '更新成功',
  '创建成功': '创建成功',
  '删除成功': '删除成功',
  '确定删除这个管理员吗': '确定删除这个管理员吗？',
  '注销': '注销',
  '注销名册': '注销名册',
  '账户注销': '账户注销',
  '确认注销': '确认注销',
  '正在核验余额…': '正在核验余额…',
  '注销成功，ID 已进注销仓库，余额已回收': '注销成功，ID 已进注销仓库，余额已回收',
  '注销失败：': '注销失败：',
  '注销原因': '注销原因',
  '进注销仓库留痕': '进注销仓库留痕',
  '请填写注销原因': '请填写注销原因',
  '将回收金额': '将回收金额',
  '资金去向': '资金去向',
  '流水备注': '流水备注',
  '该账号已注销过，请勿重复操作': '该账号已注销过，请勿重复操作',
  '注销单号': '注销单号',
  '已回收': '已回收',
  '脱敏手机': '脱敏手机',
  '注销时余额': '注销时余额',
  '可否再用': '可否再用',
  '可复用': '可复用',
  '不可': '不可',
  '账号已删除': '账号已删除',
  '注销时间': '注销时间',

  // ---- 资金发行 / 回收审核（老陈 2026-09-29 定调：只有陈少华与吴琼）----
  '已提交，待发行审核：需陈少华或吴琼凭体系外收款凭据批准后入账': '已提交，待发行审核：需陈少华或吴琼凭体系外收款凭据批准后入账',
  '无发行审核权限：仅陈少华与吴琼可批准发行': '无发行审核权限：仅陈少华与吴琼可批准发行',
  '请填写体系外收款凭据：没收到真金白银就不发行货币': '请填写体系外收款凭据：没收到真金白银就不发行货币',
  '后台发行审核': '后台发行审核',
  '发行审核通过，已入账': '发行审核通过，已入账',
  '审核发行': '审核发行',
  '待发行审核': '待发行审核',
  '发行审核 · 批准入账': '发行审核 · 批准入账',
  '确认发行': '确认发行',
  '体系外收款凭据': '体系外收款凭据',
  '银行流水号 / 支付宝微信收款订单号': '银行流水号 / 支付宝微信收款订单号',
  '如：BANK20260929001 / 2026092922001xxxx': '如：BANK20260929001 / 2026092922001xxxx',
  '顺序：先收到体系外的真金白银 → 授权 → 才发行体系内流通积分。凭据写入渠道流水号备查。': '顺序：先收到体系外的真金白银 → 授权 → 才发行体系内流通积分。凭据写入渠道流水号备查。',
  '订单号：': '订单号：',
  '提交后订单进入「待支付」，不会立即入账。需陈少华或吴琼在列表点「审核发行」并填写体系外收款凭据后才发行流通积分': '提交后订单进入「待支付」，不会立即入账。需陈少华或吴琼在列表点「审核发行」并填写体系外收款凭据后才发行流通积分',
  '没收到真金白银就不发行货币': '没收到真金白银就不发行货币',
  '无资金审核权限：仅陈少华与吴琼可审核提现': '无资金审核权限：仅陈少华与吴琼可审核提现',
  '请填写打款凭据：必须先把钱打给用户，才能回收流通积分': '请填写打款凭据：必须先把钱打给用户，才能回收流通积分',
  '无审核权限': '无审核权限',
  '体系外打款凭据': '体系外打款凭据',
  '银行流水号 / 支付宝微信订单号': '银行流水号 / 支付宝微信订单号',
  '顺序：先把真金白银打给用户 → 才回收流通积分。没填凭据不会扣减企业余额。': '顺序：先把真金白银打给用户 → 才回收流通积分。没填凭据不会扣减企业余额。',
};
